/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { colors } from '@lmc/common/constants'
import { type DatePickerProps, Input, Row } from 'antd'
import React, { type CSSProperties } from 'react'
import styled from 'styled-components'
import Icon from '../../general/Icon'
import InputDatePicker from '../InputDatePicker'
import InputRadioGroup from '../InputRadioGroup'

export type NextReviewFieldProps = {
  localisation?: { title: string; additionalInfo?: string; datePicker?: string }
  timeOptions: Array<{ value: string; label: string }>
  additionalInfo?: boolean
  dateValue?: string
  additionalInfoValue?: string
  timeValue?: string
  datePickerOnChange?: any
  radioGroupOnChange?: any
  textAreaOnChange?: any
  isMobile?: boolean
  format?: string
  disabledDate?: DatePickerProps['disabledDate']
  disabled?: boolean
}

const InputRadioGroupStyled = styled(InputRadioGroup)`
  .ant-radio-group {
    display: flex;
    flex-direction: row;
    margin-top: 15px;
  }

  .ant-radio-wrapper {
    margin: 0;
  }

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    .ant-radio-group {
      flex-direction: column;
      gap: 8px;
    }
  }
`

const MainContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`
const NextReview = styled.div`
  font-weight: 700;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin-top: 8px;
  }
`
const CalendarIcon = styled(Icon)`
  font-size: 24px;
  margin-left: 20px;
  margin-right: 20px;
  transform: 'translateY(5px)';
  display: 'inline-block';
`

const DateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`

const NextReviewField = ({
  localisation,
  dateValue,
  timeOptions,
  additionalInfo,
  additionalInfoValue,
  timeValue,
  datePickerOnChange,
  radioGroupOnChange,
  textAreaOnChange,
  format,
  disabledDate,
  disabled = false
}: NextReviewFieldProps) => {
  const styles = {
    container: {
      display: 'flex',
      borderRadius: 15,
      background: colors.white,
      padding: '16px 24px 16px 24px',
      marginBottom: 24
    },
    additionalInfo: {
      fontWeight: 700,
      marginBottom: 10
    },
    textArea: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginBottom: 20,
      width: '100%'
    },
    datePicker: { marginRight: 10 },
    textAreaWrapper: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      marginTop: '10px'
    },
    radiosWrapper: {
      display: 'flex'
    }
  }

  const { TextArea } = Input

  return (
    <Row
      style={{
        ...styles.container,
        opacity: disabled ? 0.4 : 1,
        pointerEvents: disabled ? 'none' : 'auto'
      }}
    >
      {additionalInfo && (
        <div style={styles.textAreaWrapper as CSSProperties}>
          <div style={styles.additionalInfo}>
            {localisation?.additionalInfo}
          </div>
          <TextArea
            rows={4}
            style={styles.textArea}
            value={additionalInfoValue}
            onChange={textAreaOnChange}
          />
        </div>
      )}
      <MainContainer>
        <NextReview>{localisation?.title}</NextReview>
        <DateContainer>
          <CalendarIcon size={24} name="CalendarOutlined" />
          <InputDatePicker
            disabledDate={disabledDate}
            format={format}
            value={dateValue}
            onChange={datePickerOnChange}
            localization={{
              placeholder: localisation?.datePicker,
              errorMessage: 'Please enter a date!'
            }}
            style={styles.datePicker}
            wrapFormItem={false}
          />
        </DateContainer>
        <InputRadioGroupStyled
          noBorder
          // @ts-ignore
          value={timeValue}
          layout="row"
          options={timeOptions}
          localization={{ errorMessage: 'Please select an option!' }}
          onChange={radioGroupOnChange}
        />
      </MainContainer>
    </Row>
  )
}

export default NextReviewField
